import React from "react";
import "./Checkout.css";
import Subtotal from "./Subtotal";
import CheckoutProduct from "./CheckoutProduct";
//import { useStateValue } from "./StateProvider";
import { useSelector } from "react-redux";
import { selectUser } from "./redux/cart/cartSlice";

function Checkout() {
  //const [{ basket, user }, dispatch] = useStateValue();x
  const { user, basket } = useSelector(selectUser);

  //const cartItem = JSON.parse(sessionStorage.getItem("test"));

  return (
    <div className="checkout">
      <div className="checkout__left">
        <img
          className="checkout__ad"
          src="https://media-exp1.licdn.com/dms/image/C561BAQHCZ83vKVJVkg/company-background_10000/0?e=2159024400&v=beta&t=6EhQmBBtUy-Sa0neSKmPHus9woro1FRyJQvF8bkqAH4"
          alt=""
        />
        <div className="checkout__leftdata">
          <h3>Hello, {user?.email}</h3>
          <h2 className="checkout__title">Your Shopping Cart</h2>
          {basket?.length ? (
            basket?.map((item) => (
              <CheckoutProduct
                id={item.id}
                title={item.title}
                image={item.image}
                price={item.price}
                rating={item.rating}
              />
            ))
          ) : (
            <div className="checkout__cart">
              <img
                src="https://m.media-amazon.com/images/G/31/cart/empty/kettle-desaturated._CB424694257_.svg"
                alt=""
              />
            </div>
          )}
        </div>
      </div>
      <div className="checkout__right">
        <Subtotal />
      </div>
    </div>
  );
}

export default Checkout;
